export default "__VITE_ASSET__CwqS_m5L__"